import { React, useEffect, useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiZoomIn } from 'react-icons/fi';
import Moment from 'react-moment';
import Breadcrumb from '../../components/Breadcrumbs';
import { Typography } from '@mui/material';

import api from '../../services/api';
import UserPermission from '../../components/UserPermission';

import './styles.css';
import Table from "../../components/Table";
import MultiManual from '../../components/Manual/MultiManual';


export default function ResolvedComplaints() {
  const navigate = useNavigate();

  // Permissão do usuário no sistema
  let userPermission = UserPermission();

  const [complaints, setComplaints] = useState([]);

  const columns = useMemo(
    () => [
      {
        Header: 'CÓDIGO',
        accessor: 'reference',
      },
      {
        Header: 'Data de Abertura',
        accessor: 'createdAt',
        Cell: ({ cell: { value } }) => {
          return (
            <>
              <Moment locale format={'DD/MM/YYYY'} >
                {value}
              </Moment>
            </>
          )
        }
      },
      {
        Header: 'Última Atualização',
        accessor: 'updatedAt',
        Cell: ({ cell: { value } }) => {
          return (
            <>
              <Moment locale format={'DD/MM/YYYY'} >
                {value}
              </Moment>
            </>
          )
        }
      },
      {
        Header: 'Tipo',
        accessor: 'area',
        Cell: ({ cell: { value } }) => {
          return (
            <>
              <span>
                {value.split("T")[0]}
              </span>
            </>
          )
        }
      },
      {
        Header: 'Executor Responsável',
        accessor: 'nameExecutor',
        Cell: ({ cell: { value } }) => {
          return (
            <>
              <span>
                {value}
              </span>
            </>
          )
        }
      },
      {
        Header: 'Status',
        accessor: 'status',
        Cell: ({ cell: { value } }) => {
          return (
            <>
              {value === 'Resolvido' ?
                <span className="resolvido">
                  {value}
                </span>
                :
                <span className="indeferido">
                  {value}
                </span>
              }
            </>
          )
        }
      },
      {
        Header: 'Homologado',
        accessor: 'validationControl',
        Cell: ({ cell: { value } }) => {
          return (
            <>
              <span>
                {value === false ? "Não" : "Sim"}
              </span>
            </>
          )
        }
      },
      {
        Header: 'Descrição',
        accessor: 'description',
        Cell: ({ cell: { value } }) => {
          return (
            <>
              <span>
                {value.length < 50 ? value : value.substr(0, 60) + "..."}
              </span>
            </>
          )
        }
      },
      {
        Header: () => null,
        id: 'edit',
        Cell: ({ row }) => (
          <div style={{ cursor: 'pointer' }} onClick={() => navigate(`/details/${row.original.id}`, { state: { from: [{ name: 'Ocorrências Atrasadas', href: '/no-location-complaints' }] } })}>
            <FiZoomIn
              size={20}
              color="#22543d"
            />
          </div>
        ),
      },
    ],
    []
  );

  /* Lista de items */
  useEffect(() => {
    /* Define o filtro da listagem de ocorrências */
    let filter = { where: {} }

    /* Filtro das ocorrências */
    filter.where.or = [{ "status": "Resolvido" }, { "status": "Indeferido" }];

    api.get(`${userPermission}/complaints?filter=${JSON.stringify(filter)}`).then(response => {
      /* Adiciona a propriedade nomeExecutor na lista de ocorrências */
      for (var i = 0; i < response.data.length - 1; i++) {
        response.data[i]["nameExecutor"] = ""
      }

      /* Se o usuário logado não for executor */
      if (userPermission !== 'executor') {
        /* Realiza o get dos usuários */
        api.get(`${userPermission}/users`).then(res => {
          let nameExecutor = '';
          /* para cada ocorrência */
          response.data.forEach(input => {
            try {
              /* Obtem o nome do executor para cada ocorrência */
              nameExecutor = res.data.find(user => user.id === input.executorId);
              /* Adiciona o nome do executor */
              input.nameExecutor = nameExecutor.name;
            } catch (error) {
              input.nameExecutor = 'Sem executor';
            }
          });
          setComplaints(response.data);
        });
      } else {
        response.data.forEach(input => {
          input.nameExecutor = localStorage.getItem('NameUser');
        });

        setComplaints(response.data);
      }
    });
  }, [userPermission]);

  return (
    <div>
      <div style={{ margin: 32 }}>
        <Breadcrumb
          paths={[
            { href: '/search', name: 'Ocorrências' },
            { href: '', name: 'Ocorrências Concluídas' },
          ]}
        />
      </div>
      <div className="ocorrencias-resolvidas">

        <Typography variant="h5" align="center" style={{
          margin: 8,
          color: '#103168',
          fontWeight: 600,
          marginBottom: 30,
        }}>
          Ocorrências Concluídas
        </Typography>

        <div
          style={{
            padding: 10,
            backgroundColor: '#FFFBE8',
            color: 'rgba(0,0,0,0.8)',
            borderRadius: 7,
            width: '100%',
          }}
        >
          <p>Digite abaixo o código da ocorrência que você gostaria de visualizar o status.</p>
        </div>

        <div id='resolved-list'>
          <Table columns={columns} data={complaints} />
        </div>
      </div>

      <MultiManual
        components={[
          {
            id: 'table-occurrences-input',
            message: `Aqui você pode procurar uma ocorrência`,
            padding: 20
          },
          {
            id: 'resolved-list',
            message: `Aqui é a lista de ocorrências filtradas`,
            padding: 20,
          }
        ]}
      />
    </div>
  );
};
